// extracted by mini-css-extract-plugin
export default {"WrapperCreateSpecificationParameter":"WrapperCreateOrEditSpecificationParameter_WrapperCreateSpecificationParameter__JRNk1"};